<nav
    class="navbar navbar-expand-lg navbar-light bg-secondary position-absolute p-2">
    <a class="navbar-brand" (click)="goBack()">
        <img
            src="assets/images/logo_lccv_icon.png"
            class="img-fluid mr-1"
            width="40px" />
        <div class="brand-text d-inline-block text-white">
            <strong>LCCV</strong>
        </div>
    </a>
</nav>

<div class="bg-logo bg-logo-custom"></div>

<div
    class="d-flex flex-column justify-content-center align-items-center"
    style="min-height: 100vh">
    <div
        class="badge-warning rounded p-4 text-center access-denied-card"
        style="max-width: 600px">
        <div
            class="d-flex flex-row justify-content-center align-items-center mb-3">
            <h1
                class="mb-0 mr-3 pr-3 align-top border-right inline-block align-content-center text-danger">
                403
            </h1>
            <h2 class="mb-0 font-weight-normal lead text-dark" id="desc">
                Acesso Negado
            </h2>
        </div>

        <div class="text-muted mb-4">
            <p class="mb-3">
                <strong>{{ accessDeniedReason }}</strong>
            </p>

            <div
                *ngIf="isPortalDenied"
                class="mb-3 p-3 info-section portal-section rounded">
                <h6 class="text-danger mb-2">
                    <span
                        class="material-icons mr-1"
                        style="font-size: 18px; vertical-align: middle"
                        >warning</span
                    >
                    Portal Requerido
                </h6>
                <div class="text-dark">
                    Para acessar esta funcionalidade, você precisa ter acesso ao
                    portal
                    <strong class="text-primary">{{ portal }}</strong>
                </div>
            </div>

            <div
                *ngIf="isPermissionDenied"
                class="mb-3 p-3 info-section permission-section rounded">
                <h6 class="text-danger mb-2">
                    <span
                        class="material-icons mr-1"
                        style="font-size: 18px; vertical-align: middle"
                        >lock</span
                    >
                    Permissões Necessárias
                </h6>
                <div class="text-dark mb-2">
                    Para acessar esta funcionalidade, você precisa das seguintes
                    permissões:
                </div>
                <ul class="list-unstyled">
                    <li
                        *ngFor="let permission of permissions"
                        class="permission-badge">
                        <span
                            class="material-icons mr-1"
                            style="font-size: 14px; vertical-align: middle"
                            >vpn_key</span
                        >{{ permission }}
                    </li>
                </ul>
            </div>

            <div
                *ngIf="!isPortalDenied && !isPermissionDenied"
                class="mb-3 p-3 info-section contact-section rounded">
                <div class="text-dark">
                    Entre em contato com o administrador do sistema para
                    solicitar acesso.
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-center">
            <button
                type="button"
                class="btn btn-outline-primary"
                (click)="goBack()">
                <span
                    class="material-icons mr-1"
                    style="font-size: 18px; vertical-align: middle"
                    >arrow_back</span
                >
                Voltar
            </button>
        </div>
    </div>
</div>
